{
  "addresses": [
    {
      "address": {
        "addressLine1": "111 Lawrence Hill Rd",
        "addressType": "DOMESTIC",
        "city": "Cold Spring Harbor",
        "countryName": "United States",
        "countryCodeIso3": "USA",
        "countyCode": "36103",
        "countyName": "Suffolk County",
        "stateCode": "NY",
        "zipCode": "11724",
        "zipCodeSuffix": "1706"
      },
      "addressMetaData": {
        "confidenceScore": 100,
        "addressType": "Domestic",
        "deliveryPointValidation": "CONFIRMED"
      }
    }
  ],
  "overrideValidationKey": -489113428,
  "validationKey": -489113428
}
